export default __webpack_public_path__ + "static/media/plus.3898b6a8.svg";